import * as React from 'react';
import {Row} from 'antd';
import DataSelectorContainer from '../../../container/DataSelectorContainer';
import { ENABLE_FORCE_AUTH } from '../../../service/dataService';
import { Divider } from 'antd';

export interface ControlPanelProps {
    user_verify: any,
    width: any,
    height: any
}

export interface ControlPanelState {}

export default class ControlPanel extends React.Component<ControlPanelProps, ControlPanelState> {
    constructor(props: ControlPanelProps) {
        super(props);
        this.state = {
            
        };
    }
    public render() {
        let display_selector = false;
        if(!ENABLE_FORCE_AUTH){
            display_selector = true;
        }else{
            if(this.props.user_verify){
                display_selector = true;
            }
        }
        console.log(display_selector, this.props.user_verify, ENABLE_FORCE_AUTH);
        return (
            <div>
            <div className="ViewTitle2">Control Panel</div>
            <div className="ViewBox">
            {(display_selector)?<DataSelectorContainer width={this.props.width} />:<div/>}
            {/**
             * <div style={{width: "100%", height:""+(this.props.height - 40)+"px",  overflowY: "auto"}}>
                        {(display_selector)?<DataSelectorContainer />:<div/>}
                </div>
             */}
                
                   
            </div>
            </div>
            
        );
    }
}
